/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:56:04
 * @LastEditors: xgx
 * @LastEditTime: 2022-10-08 16:14:55
 */
import req from "@/utils/request";

//  列表查询
export const selectListPage = (params) => req.post("/media-service/m/douyinGrant/selectListPage", params);

//用户授权
export const getDouyinCode = (params) => req.post("/media-service/m/douyinGrant/getDouyinCode", params);

//  组织架构树
export const organTree = (params) => req.post("/manager-service/m/organization/organTree", params);

//  组织架构树
export const deleteById = (params) => req.post("/media-service/m/douyinGrant/deleteById", params);